<template>
    <ui-modal>
        <template #header>
            <h3 v-text="'Szczegóły wydania'" class="mb-0" />
        </template>

        <h5 v-text="'Szczegóły wydania'" class="mb-3" />

        <div class="card handover-details__summary">
            <div>
                <div class="handover-details__field">
                    <strong v-text="'Wydany przez:'" />
                    <div v-text="issuedBy.value" />
                </div>
                <div class="handover-details__field">
                    <strong v-text="'Urządzenie:'" />
                    <div class="handover-details__device">
                        <img
                            v-if="issuedBy.deviceImage"
                            :src="issuedBy.deviceImage"
                        />
                        <a-icon
                            v-else
                            icon="Info"
                            width="20"
                            height="20"
                            class="text-orange"
                        />
                        <span v-text="issuedBy.deviceName || '---'" />
                    </div>
                </div>
            </div>

            <div>
                <div class="handover-details__field">
                    <strong v-text="'Data wydania:'" />
                    <div v-text="`${issuedAt.date} ${issuedAt.time}`" />
                </div>
                <div class="handover-details__field">
                    <strong v-text="'Operator:'" />
                    <div v-text="operatorName" />
                </div>
            </div>

            <div>
                <div class="handover-details__field">
                    <strong v-text="'Wartość:'" />
                    <div v-text="valueToCurrency(bags.value)" />
                </div>
                <div class="handover-details__field">
                    <strong v-text="'Liczba worków:'" />
                    <div v-text="bagsCount" />
                </div>
            </div>
        </div>

        <h5 v-text="`Zawartość wydania (${bagsCount})`" class="mb-3" />

        <div class="handover-details__bags">
            <article
                v-for="(bag, bagIndex) in bags.list"
                :key="bagIndex"
                class="card handover-bag"
            >
                <img
                    v-if="bagIcon(bag.type)"
                    :src="bagIcon(bag.type)"
                    class="handover-bag__icon"
                    alt=""
                />
                <div class="handover-bag__body">
                    <div>
                        <strong v-text="'Frakcja:'" /> {{ bag.name }}
                    </div>
                    <div>
                        <strong v-text="'Plomba:'" /> {{ bag.sealNumber || '---' }}
                    </div>
                    <div>
                        <strong v-text="'Data zamknięcia:'" /> {{ closedAt(bag.closedDate) }}
                    </div>
                    <div>
                        <strong v-text="'Wartość:'" /> {{ valueToCurrency(bag.value) }}
                    </div>
                </div>
                <the-btn
                    v-tooltip="'Wycofaj worek z wydania'"
                    class="handover-bag__remove btn-outline-custom btn-sm btn-icon"
                    :disabled="!!restoringSeal"
                    :icon="isBagRestoring(bag.sealNumber) ? 'Spinner': 'Bin'"
                    :loading-status="isBagRestoring(bag.sealNumber) ? 'loading' : null"
                    @click="restore(bag)"
                />
            </article>
        </div>
    </ui-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import handoverMixin from './handover.mixin'

export default {
    mixins: [handoverMixin],

    data: () => ({
        restoringSeal: null
    }),

    computed: {
        ...mapGetters('handoversReport', ['handovers']),

        handover() {
            const index = this.$store.getters.getModal?.args?.index
            return this.handovers[index] || {}
        }
    },

    methods: {
        ...mapActions('handoversReport', ['restoreBag']),

        closedAt(date) {
            if (!date) return '---'

            return this.$moment(date).format('DD-MM-YYYY')
        },

        bagIcon(type) {
            if (!type) return null

            return require(`@/assets/img/drs/bag-${type}.svg`)
        },

        isBagRestoring(sealNumber) {
            return this.restoringSeal === sealNumber
        },

        async restore(bag) {
            if (!bag.sealNumber) return

            const lastBag = this.bags.count === 1

            this.restoringSeal = bag.sealNumber
            await this.restoreBag(bag.sealNumber)

            // Check the restored seal
            if (lastBag && !this.bags.list.some(item => item.sealNumber === bag.sealNumber)) {
                this.$emit('close-modal')
                return
            }

            this.restoringSeal = null
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.handover-details__summary {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem 1.5rem;
    margin-bottom: 1.5rem;
    padding: 1rem;
    color: var(--color-primary);
    font-size: 0.875rem;

    @include media-breakpoint-up(lg) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

.handover-details__field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;

    &:last-child {
        margin-bottom: 0;
    }
}

.handover-details__device {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    img,
    .a-icon {
        width: 20px;
        height: 20px;
        flex: 0 0 auto;
    }
}

.handover-details__bags {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    overflow-y: auto;

    @include media-breakpoint-up(lg) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        max-height: 22rem;
    }
}

.handover-bag {
    flex-direction: row;
    padding: 1rem 3rem 1rem 0;
    color: var(--color-primary);
    font-size: 0.875rem;
}

.handover-bag__icon {
    width: 60px;
    height: 60px;
    flex: 0 0 auto;
}

.handover-bag__body {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.handover-bag__remove {
    position: absolute;
    top: 1rem;
    right: 1rem;
}
</style>
